import { instance } from "./api";

// import api from "./api";

export async function getPlottingList(payloads) {
  const { results, page, filters } = payloads;

  const applyFilter = filters?.length > 0 ? "&filter=" + filters : "";
  const response = await instance.get(
    `admin/getPlot?limit=${results}&page=${page}${applyFilter}`
  );
  return response.data;
}
export async function getPlotting(plot_auto_id) {
  const response = await instance.get(`admin/getPlot/${plot_auto_id}`);
  return response.data;
}

export async function getPlottingData(payload) {
  const { filter, id } = payload;
  let applyFilter = filter === "" ? "" : `?filter=${filter}`;
  const response = await instance.get(`user/plot/${id}${applyFilter}`);
  return response.data;
}

export async function createPlottingData(payload) {
  const form = new FormData();
  form.append("Loc_Auto_ID", payload.Loc_Auto_ID);
  form.append("Plot_Code", payload.Plot_Code);
  form.append("Plot_Name", payload.Plot_Name);
  form.append("Plot_Area", payload.Plot_Area);
  form.append("Total_Planting_Count", payload.Total_Planting_Count);
  form.append("Latitude", payload.Latitude);
  form.append("Longitude", payload.Longitude);
  form.append("Altitude_meter", payload.Altitude_meter);
  // new changes - tag v3.0.1
  form.append("Land_Use", payload.Land_Use);
  form.append("Aspect", payload.Aspect);
  form.append("Soil_Texture", payload.Soil_Texture);
  form.append("Presence_of_Weed_or_Grass", payload.Presence_of_Weed_or_Grass);
  form.append("Location", payload.Location);

  const response = await instance.post("admin/addPlot", form);
  return response;
}

export async function updatePlottingData(payload) {
  const form = new FormData();
  form.append("Loc_Auto_ID", payload.Loc_Auto_ID);
  form.append("Plot_Code", payload.Plot_Code);
  form.append("Plot_Name", payload.Plot_Name);
  form.append("Plot_Area", payload.Plot_Area);
  form.append("Total_Planting_Count", payload.Total_Planting_Count);
  form.append("Latitude", payload.Latitude);
  form.append("Longitude", payload.Longitude);
  form.append("Altitude_meter", payload.Altitude_meter);
  form.append("Is_Active", payload.Is_Active);

  // new changes - tag v3.0.1
  form.append("Land_Use", payload.Land_Use);
  form.append("Aspect", payload.Aspect);
  form.append("Soil_Texture", payload.Soil_Texture);
  form.append("Presence_of_Weed_or_Grass", payload.Presence_of_Weed_or_Grass);
  form.append("Location", payload.Location);

  const response = await instance.post(
    `admin/updatePlot/${payload.params}`,
    form
  );
  return response;
}
class PlottingService {
  fetchPlotData(payload) {
    if (payload) {
      return instance.get(`admin/getPlot/` + payload).then((res) => res.data);
    } else {
      return instance.get(`admin/getPlot`).then((res) => res.data);
    }
  }

  async addNewPlottingData(payload) {
    const form = new FormData();
    form.append("Loc_Auto_ID", payload.values.Loc_Auto_ID);
    form.append("Plot_Code", payload.values.Plot_Code);
    form.append("Plot_Name", payload.values.Plot_Name);
    form.append("Plot_Area", payload.values.Plot_Area);
    form.append("Total_Planting_Count", payload.values.Total_Planting_Count);
    form.append("Latitude", payload.values.Latitude);
    form.append("Longitude", payload.values.Longitude);
    form.append("Altitude_meter", payload.values.Altitude_meter);

    const response = await instance.post("admin/addPlot", form);
    return response;
  }

  async updatePlotData(payload) {
    const form = new FormData();
    form.append("Loc_Auto_ID", payload.values.Loc_Auto_ID);
    form.append("Plot_Code", payload.values.Plot_Code);
    form.append("Plot_Name", payload.values.Plot_Name);
    form.append("Plot_Area", payload.values.Plot_Area);
    form.append("Total_Planting_Count", payload.values.Total_Planting_Count);
    form.append("Latitude", payload.values.Latitude);
    form.append("Longitude", payload.values.Longitude);
    form.append("Altitude_meter", payload.values.Altitude_meter);
    form.append("Is_Active", payload.values.Is_Active);

    const response = await instance.post(
      `admin/updatePlot/${payload.values.idLs}`,
      form
    );
    return response;
  }
}

export default new PlottingService();
